export default __webpack_public_path__ + "static/media/goblet.d8b6b319.png";